<template>
  <ul-page class="page-virtual-coursePage" :fullHeader="false" higher>
    <template v-slot:right>
      <div class="page-header-right">
        <LoginUser></LoginUser>
      </div>
    </template>
    <div class="info-top">
      <div class="page-top-shadow">
        <div class="content">
          <div class="cover-wrapper">
            <img :src="courseInfo.cover || homePage">
          </div>
          <div class="course-info">
            <div class="title">{{ courseInfo.name }}</div>
            <div class="course-info-items" v-if="courseInfo.type == 2">
              <div class="studytime">
                <span>课程学时：</span>
                <span>{{ courseInfo.studytime }}</span>
              </div>
              <div>
                <span>学段：</span>
                <span>{{ courseInfo.academic }}</span>
              </div>
            </div>
            <div class="course-info-items" v-else >
              <div>
                <span>负责教师：</span>
                <span>{{ courseInfo.teacher }}</span>
              </div>
              <div class="studytime">
                <span>课程学时：</span>
                <span>{{ courseInfo.studytime }}</span>
              </div>
              <div>
                <span>学校：</span>
                <span>{{ courseInfo.school }}</span>
              </div>
              <div>
                <span>适合专业：</span>
                <span>{{ courseInfo.speciality }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="tabs-wrapper">
        <div class="tabs">
          <div class="tab" :class="{'is-active': selectCurrentType === 1}" @click="selectType(1)">课程介绍</div>
          <div class="tab" :class="{'is-active': selectCurrentType === 2}" @click="selectType(2)" v-if="courseInfo.type == 2">课程目录</div>
          <div class="tab" :class="{'is-active': selectCurrentType === 2}" @click="selectType(2)" v-else>实验资源</div>
          <div class="tab" :class="{'is-active': selectCurrentType === 3}" @click="selectType(3)">团队成员</div>
        </div>
      </div>
      <div class="tab-content" v-show="selectCurrentType === 1">
        <richtext :content="courseInfo.introduce" v-if="courseInfo.type == 1"></richtext>
        <div class="ai-content" v-else >
          <div class="content-item">
            <h3>课程简介</h3>
            <richtext :content="courseInfo.introduce"></richtext>
          </div>
          <div class="content-item">
            <h3>课程目标</h3>
            <richtext :content="courseInfo.teachTarget"></richtext>
          </div>
          <div class="content-item">
            <h3>课程内容</h3>
            <richtext :content="courseInfo.teachContent"></richtext>
          </div>
          <div class="content-item">
            <h3>预期效果</h3>
            <richtext :content="courseInfo.effect"></richtext>
          </div>
        </div>
      </div>
      <div class="tab-content" v-show="selectCurrentType === 2">
        <div class="course-directory"  v-if="courseInfo.type == 2">
          <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(item, index) in courseInfo.experimentList"  :title="item.title" :name="index + 1" :key="item.id">
              <ul class="menu-list">
                <li v-for="menu in item.menuList" :key="menu.id" @click="toAiExperient(item.url)">
                  <i class="iconfont icon-mulu-kechengxinxi"></i>
                  <div class="name">{{  menu.menuName  }}</div>
                </li>
              </ul>
              <div class="resource-title">教学资源包</div>
              <ul class="menu-list">
                <li v-for="(file, index) in item.fileList" :key="index" @click="toAiExperient(file.fileUrl)">
                  <i class="iconfont" :class="[fileIcon(file.fileUrl)]"></i>
                  <div class="name">{{  file.fileName  }}</div>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-for="item in courseInfo.experimentList" :key="item.id" class="experiment" v-else >
          <div class="experiment-left">
            <img :src="item.cover || homePage">
            <div>
              <div class="title">{{ item.title }}</div>
              <div class="num">
                <i class="iconfont icon-person-times_stroke"></i>实验人次：{{ item.experimentTimes }}
              </div>
            </div>
          </div>
          <div>
            <ul-button hollow @click="goDetails(item)" size="small">查看实验详情</ul-button>
          </div>
        </div>
      </div>
      <div class="tab-content" v-show="selectCurrentType === 3">
        <div v-for="item in courseInfo.teamList" :key="item.id" class="tea-info">
          <img :src="item.picurl || avatar">
          <div class="info">
            <div class="top">
              <span class="name">{{ item.teacher }}</span>
              <span class="line" v-show="item.teacher"></span>
              <span class="school">{{ item.school }}</span>
            </div>
            <div class="introduce">
              {{ item.introduce }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ul-page>
</template>

<script>
import LoginUser from 'pc/components/page/user'
import Richtext from 'pc/components/richtext.vue'
import homePage from '@/assets/images/virtual/homePage.png'
import homeBanner from '@/assets/images/virtual/home_banner.png'
import avatar from '@/assets/images/avatar.png'
import { getCourseDetails } from '@/api/courseApi/virtual.js'
import { fileIcon } from '@/utils/file.js'
export default {
  components: {
    LoginUser,
    Richtext
  },
  computed: {
    courseId () {
      return this.$route.params.id
    },
  },
  data() {
    return {
      activeNames: [1],
      homePage,
      homeBanner,
      avatar,
      selectCurrentType: 1,
      courseInfo: {}
    }
  },
  created() {
    this.courseDetails()
  },
  methods: {
    fileIcon,
    goDetails(item) {
      window.open(`#/virtual/experimentPage/${item.id}`)
    },
    courseDetails() {
      getCourseDetails({courseId: this.courseId})
      .then(({result})=>{
        if (result.name) {
          document.title = result.name
        }
        this.courseInfo = result
      })
    },
    selectType(type) {
      this.selectCurrentType = type
    },
    toAiExperient (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.page-virtual-coursePage {
  .ul-page__body-content {
    width: 100%;
    background-color: inherit;
  }
  .main-content {
    margin: 32px auto 80px;
    width: 1170px;
    background-color: #fff;
    padding-top: 10px;
  }
  .page-top-shadow {
    .content {
      width: 1170px;
    }
  }
  .el-collapse-item__header{
    color: $--color-text-base;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    background-color: #f8f8f8;
    padding: 0 16px;
  }
  .el-collapse-item__content{
    color: $--color-text-base;
  }
  @media (max-width: 1200px) {
    .main-content {
      width: 980px;
    }
    .page-top-shadow {
      .content {
        width: 980px;
      }
    }
  }
}
.info-top {
  background-image: url('~@/assets/images/virtual/home_banner.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .page-top-shadow {
    padding: 48px 0;
    .content {
      margin: 0 auto;
      display: flex;
      .cover-wrapper {
        margin-right: 28px;
        img {
          width: 480px;
          height: 270px;
          display: block;
        }
      }
      .course-info {
        color: #fff;
        .title {
          @include ellipsis2;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 24px;
        }
        .course-info-items {
          >div {
            margin-bottom: 12px;
            display: flex;
            span {
              display: block;
              @include ellipsis2;
              &:first-child {
                min-width: max-content;
              }
            }
          }
          .studytime {
            span {
              -webkit-line-clamp: 1;
            }
          }
        }
      }
    }
  }
}
.tabs-wrapper{
  display: flex;
  justify-content: center;
  border-bottom: $--border-base;
}
.tabs{
  display: flex;
  .tab{
    padding: 10px 0;
    margin: 0 20px;
    line-height: 24px;
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
    &.is-active{
      border-bottom: solid 3px $--color-primary;
      color: $--color-primary;
    }
  }
}
.tab-content {
  padding: 24px;
  .experiment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    border-bottom: 1px dashed #E3E3E9;
    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    &:first-child {
      padding-top: 0;
    }
    .experiment-left {
      display: flex;
      img {
        width: 142px;
        height: 80px;
        margin-right: 16px;
      }
      .title {
        font-size: 16px;
        margin-bottom: 12px;
      }
      .num {
        color: #969696;
        i {
          font-size: 14px;
          margin-right: 8px;
        }
      }
    }
  }
  .tea-info {
    display: flex;
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 88px;
      height: 88px;
      border-radius: 88px;
      margin-right: 16px;
    }
    .info {
      .top {
        display: flex;
        align-items: center;
        line-height: 1.5;
        margin-bottom: 12px;
        .name {
          font-size: 18px;
          font-weight: 600;
        }
        .line {
          margin: 0 10px;
          border-left: 1px solid #E3E3E9;
          height: 16px;
        }
        .school {
          font-size: 16px;
        }
      }
    }
  }
  .ai-content{
    .content-item{
      margin-bottom: 24px;
    }
    h3{
      margin-top: 0;
      margin-bottom: 8px;
    }
  }
  .introduce {
    font-size: 16px;
  }
  .course-directory {
    .menu-list {
      margin-left: 16px;
      li {
        display: flex;
        align-items: center;
        padding: 12px 16px 12px 0;
        font-size: 16px;
        line-height: 24px;
        cursor: pointer;
        &:not(:last-child) {
          border-bottom: $--border-base;
        }
        &:hover {
          color: $--color-primary;
        }
        .name {
          margin-left: 12px;
        }
      }
    }
    .resource-title{
      line-height: 36px;
      font-weight: 600;
      font-size: 16px;
      padding: 0 16px;
    }
  }
}
</style>